export default __webpack_public_path__ + "static/media/undraw_authentication_fsn5.6b628a56.png";